import { createElement } from 'react';
import { useSelector } from 'react-redux';
import { getFormStack, currentFormInfo } from 'features/common/formSlice';
import { SidePanelHeader } from 'components/Layout/SidePanel/SidePanelHeader';
import { ItemForm } from 'forms/ItemForm';
import { LinkForm } from 'forms/LinkForm';
import { ToolForm } from 'forms/ToolForm';
import { PartForm } from 'forms/PartForm';
import { ZoneForm } from 'forms/ZoneForm';
import { AssetForm } from 'forms/AssetForm';
import { GroupForm } from 'forms/GroupForm';
import { AccountForm } from 'forms/AccountForm';
import { ContentForm } from 'forms/ContentForm';
import { HotspotForm } from 'forms/HotspotForm';
import { ItemTagForm } from 'forms/ItemTagForm';
import { ClientForm } from 'forms/ClientForm';
import { AudienceForm } from 'forms/AudienceForm';
import { CategoryForm } from 'forms/CategoryForm';
import { LocationForm } from 'forms/LocationForm';
import { ProcedureForm } from 'forms/ProcedureForm';
import { CompanionForm } from 'forms/CompanionForm';
import { NewsFlashForm } from 'forms/NewsFlashForm';
import { PartGroupForm } from 'forms/PartGroupForm';
import { AssetExportForm } from 'forms/AssetExportForm';
import { ToolCategoryForm } from 'forms/ToolCategoryForm';
import { PartCategoryForm } from 'forms/PartCategoryForm';
import { ContentVersionForm } from 'forms/ContentVersionForm';
import { selectEditItem } from 'features/common/editItemSlice';
import { selectEditZone } from 'features/common/editZoneSlice';
import { ContentInventoryForm } from 'forms/ContentInventoryForm';
import { FiServer } from 'react-icons/fi';
import { DeploymentPackageForm } from 'forms/jobs/Management/DeploymentPackage';
import { ExportAssetDetailsForm } from 'forms/ExportAssetDetailsForm';

function mapForm(form, editZone, editItem) {
    switch (form.formKey) {
        case 'accountForm':
            return {
                icon: <FiServer />,
                header: 'Account Panel',
                component: AccountForm,
                params: {
                    accountId: form.editObjectId,
                },
                ...form,
            };
        case 'contentForm':
            return {
                icon: <FiServer />,
                header: 'Content Panel',
                component: ContentForm,
                params: {
                    contentId: form.editObjectId,
                    ...form.editObjectInfo,
                },
                ...form,
            };
        case 'contentVersionForm':
            return {
                icon: <FiServer />,
                header: 'Content Version Panel',
                component: ContentVersionForm,
                params: {
                    contentId: form.editObjectId,
                },
                ...form,
            };
        case 'zoneForm':
            return {
                icon: <FiServer />,
                header: 'Zone Panel',
                component: ZoneForm,
                params: {
                    zone: editZone,
                },
                ...form,
            };
        case 'itemForm':
            return {
                icon: <FiServer />,
                header: 'Item Panel',
                component: ItemForm,
                params: {
                    item: editItem,
                },
                ...form,
            };
        case 'linkForm':
            return {
                icon: <FiServer />,
                header: 'Link Panel',
                component: LinkForm,
                params: {
                    linkId: form.editObjectId,
                },
                ...form,
            };
        case 'groupForm':
            return {
                icon: <FiServer />,
                header: 'Group Panel',
                component: GroupForm,
                params: {
                    groupId: form.editObjectId,
                },
                ...form,
            };
        case 'categoryForm':
            return {
                icon: <FiServer />,
                header: 'Category Panel',
                component: CategoryForm,
                params: {
                    categoryId: form.editObjectId,
                },
                ...form,
            };
        case 'managementDeployForm':
            return {
                icon: <FiServer />,
                header: 'Deployment Package Panel',
                component: DeploymentPackageForm,
                params: {
                    deploymentId: form.editObjectId,
                },
                ...form,
            };
        case 'hotspotForm':
            return {
                icon: <FiServer />,
                header: 'Hotspot Panel',
                component: HotspotForm,
                params: {
                    hotspotId: form.editObjectId,
                },
                ...form,
            };
        case 'assetForm':
            return {
                icon: <FiServer />,
                header: 'Asset Panel',
                component: AssetForm,
                params: {
                    assetId: form.editObjectId,
                },
                ...form,
            };
        case 'procedureForm':
            return {
                icon: <FiServer />,
                header: 'Procedure Panel',
                component: ProcedureForm,
                params: {
                    assetId: form.editObjectId,
                },
                ...form,
            };
        case 'itemTagForm':
            return {
                icon: <FiServer />,
                header: 'Item Tag Panel',
                component: ItemTagForm,
                params: {
                    itemTagId: form.editObjectId,
                },
                ...form,
            };
        case 'clientForm':
            return {
                icon: <FiServer />,
                header: 'Client Panel',
                component: ClientForm,
                params: {
                    clientId: form.editObjectId,
                },
                ...form,
            };
        case 'audienceForm':
            return {
                icon: <FiServer />,
                header: 'Audience Panel',
                component: AudienceForm,
                params: {
                    audienceId: form.editObjectId,
                },
                ...form,
            };
        case 'assetExportForm':
            return {
                icon: <FiServer />,
                header: 'Create Export Job',
                component: AssetExportForm,
                params: {
                    assetId: form.editObjectId,
                },
                ...form,
            };
        case 'toolCategoryForm':
            return {
                icon: <FiServer />,
                header: 'Tool Category Panel',
                component: ToolCategoryForm,
                params: {
                    categoryId: form.editObjectId,
                },
                ...form,
            };
        case 'locationForm':
            return {
                icon: <FiServer />,
                header: 'Tool Location Panel',
                component: LocationForm,
                params: {
                    locationId: form.editObjectId,
                },
                ...form,
            };
        case 'toolForm':
            return {
                icon: <FiServer />,
                header: 'Tool Panel',
                component: ToolForm,
                params: {
                    toolId: form.editObjectId,
                },
                ...form,
            };
        case 'partCategoryForm':
            return {
                icon: <FiServer />,
                header: 'Part Category Panel',
                component: PartCategoryForm,
                params: {
                    partCategoryId: form.editObjectId,
                },
                ...form,
            };
        case 'partGroupForm':
            return {
                icon: <FiServer />,
                header: 'Part Group Panel',
                component: PartGroupForm,
                params: {
                    partGroupId: form.editObjectId,
                },
                ...form,
            };
        case 'partForm':
            return {
                icon: <FiServer />,
                header: 'Part Panel',
                component: PartForm,
                params: {
                    partId: form.editObjectId,
                },
                ...form,
            };
        case 'companionForm':
            return {
                icon: <FiServer />,
                header: 'Companion App Panel',
                component: CompanionForm,
                params: {
                    companionAppId: form.editObjectId,
                },
                ...form,
            };
        case 'newsFlashForm':
            return {
                icon: <FiServer />,
                header: 'News Flash Panel',
                component: NewsFlashForm,
                params: {
                    newsFlashId: form.editObjectId,
                },
                ...form,
            };
        case 'contentInventoryForm':
            return {
                icon: <FiServer />,
                header: 'Content Inventory',
                component: ContentInventoryForm,
                params: {
                    contentPayload: form.editObjectInfo,
                },
                ...form,
            };
        case 'exportAssetDetailsForm':
            return {
                icon: <FiServer />,
                header: 'Asset Details',
                component: ExportAssetDetailsForm,
                params: {
                    contentPayload: form.editObjectInfo,
                },
                ...form,
            };
    }
}

const FormDisplayer = () => {
    const formStack = useSelector(getFormStack);
    const currentFormKey = useSelector(currentFormInfo);
    const editZone = useSelector(selectEditZone);
    const editItem = useSelector(selectEditItem);

    return formStack
        .filter((form) => form.isOpen)
        .map((form) => mapForm(form, editZone, editItem))
        .map((form) => {
            return (
                <div
                    key={form.formKey}
                    style={{
                        display: form.formKey === currentFormKey ? null : 'none',
                    }}
                >
                    <SidePanelHeader
                        icon={form.icon}
                        header={form.header}
                        formKey={form.formKey}
                        data={currentFormKey === 'zoneForm' ? editZone : null}
                    />
                    {createElement(form.component, {
                        formAction: form.formAction,
                        ...form.params,
                    })}
                </div>
            );
        });
};

export { FormDisplayer };
